"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpellCheckerOptionsApi = void 0;
var SpellCheckerOptionsApi = (function () {
    function SpellCheckerOptionsApi(_control) {
        this._control = _control;
    }
    Object.defineProperty(SpellCheckerOptionsApi.prototype, "isEnabled", {
        get: function () {
            return this._control.modelManager.richOptions.spellChecker.isEnabled;
        },
        set: function (value) {
            if (value == this.isEnabled)
                return;
            if (!value) {
                this._control.modelManager.model.mainSubDocument.spellCheckerIntervalsManager.reset();
                this._control.spellChecker.updateMisspelledBoxes();
            }
            this._control.modelManager.richOptions.spellChecker.isEnabled = value;
            if (value)
                this._control.spellChecker.check();
        },
        enumerable: false,
        configurable: true
    });
    return SpellCheckerOptionsApi;
}());
exports.SpellCheckerOptionsApi = SpellCheckerOptionsApi;
